export {default as GoogleLogo} from "./google-logo";
export {default as PolLogo} from "./pol-logo";
export {default as PolTextLogo} from "./pol-text-logo";
